<template>
  <form @submit.prevent.stop class="template-startup-form">
    <div>
      <h4>{{ $t("signupflow.step-3.premium.form.title") }}</h4>
      <p class="description text-muted text-small">
        {{ $t("signupflow.step-3.premium.form.description") }}
      </p>
    </div>
    <div class="selectors">
      <CustomSelect
        class="language-select"
        v-model="language"
        :options="templateLanguages"
        :legend="$t('signupflow.step-3.premium.form.select.label')"
        label="Production language"
        i18n
      />
    </div>
    <button class="btn-signup-flow" type="button" :disabled="!language || loading" @click="createAndStart()">
      <span>
        {{$t("signupflow.step-3.premium.form.primary-btn")}}
      </span>
      <img src="@/assets/svg/arrow-right-template.svg" alt="button arrow" />
    </button>
  </form>
</template>

<script>
import CustomSelect from "@/components/CustomSelect";
export default {
  components: {
    CustomSelect
  },
  data() {
    return {
      language: "",
      standardTemplateId: null,
      standardTemplateOptions: null,
      loading: false
    };
  },
  props: {
    contentSource: {
      type: Object,
      required: true
    },
    sourceConnected: {
      type: Boolean,
      default: null
    },
  },

  methods: {
    findStandardTemplateId() {
      if(!this.isProduction) return 958;
      if(this.contentSource.contentType.name == "Shopify"){
        switch (this.language.toLowerCase()) {
          case "danish":
            return 1352;
          case "english":
            return 1353;
          default:
            return 1353;
        }
      } else {
        switch (this.language.toLowerCase()) {
          case "danish":
            return 1341;
          case "english":
            return 1342;
          default:
            return 1342;
        }
      }
    },

    createAndStart() {
      this.$store
        .dispatch("createTemplate", {
          templateName: "My first template",
          contentType: this.contentSource.contentType,
          contentSource: [this.contentSource],
          language: this.language,
          standardTemplateId: this.findStandardTemplateId()
        })
        .then((res) => {
          this.navigateToEditor(res.metadata.id)
        }).finally(() => {
          this.loading = false;
        });
      },
      
      navigateToEditor(templateId){
        this.$store.dispatch("endSignupFlow", "Standard").finally(() => {
          this.$router.push(`/templates/${templateId}?quickStart=true&templateType=template&userCompletedFlow=true`);
        })
      }
  },

  computed: {
    templateLanguages() {
      return this.$store.state.templateLanguages;
    },
    isProduction() {
      return document.location.hostname.includes("app.icrobotics.com") && !document.location.hostname.includes("staging") && !document.location.hostname.includes("dev");
    }
  }
};
</script>

<style lang="less">
.template-startup-form {
  .selectors {
    margin-top: 18px;
  }
}

#signup-flow main .template-startup-form {
  .btn-signup-flow {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;

    &:disabled {
      opacity: 0.5;
    }
  }
}
</style>
